import Question from "./Question";
import SentenceInputCompletion from "../question-types/SentenceInputCompletion";
import InputCompletion from "../question-types/InputCompletion";
import Matching from "../question-types/Matching";
import MatchingInformation from "../question-types/MatchingInformation";
import { QuestionTypes } from "../../enums";
import MultipleSelect from "../question-types/MultipleChoice";

function QuestionSet({ set, index }) {

  const renderSetBody = (type) => {
    switch (type) {
      case QuestionTypes.NOTE_COMPLETION_ONE_WORD:
      case QuestionTypes.SUMMARY_COMPLETION_TWO_WORDS:
        return <InputCompletion
          set={set}
          index={index}
        />;

      case QuestionTypes.SENTENCE_COMPLETION_ONE_WORD:
        return <SentenceInputCompletion
          set={set}
          index={index}
        />;

      case QuestionTypes.MULTIPLE_CHOICE_MULTIPLE_ANSWER:
        return (<>
          <div>
            <div dangerouslySetInnerHTML={{ __html: set.heading }} />
          </div>
          <MultipleSelect
            questionSet={set}
          />
        </>)

      case QuestionTypes.MATCHING_INFORMATION:
        return <MatchingInformation
          questionSet={set}
        />

      case QuestionTypes.MATCHING_FEATURES:
      case QuestionTypes.MATCHING_ENDINGS:
      case QuestionTypes.MATCHING_HEADINGS:
        return <Matching
          questionSet={set}
        />


      case QuestionTypes.TRUE_FALSE:
      case QuestionTypes.YES_NO:
      case QuestionTypes.MULTIPLE_CHOICE_SINGLE_ANSWER:
        return (

          <>
            <div>
              <div dangerouslySetInnerHTML={{ __html: set.heading }} />
            </div>
            {set.questions?.map((question, index) => (
              <Question
                type={set.type}
                question={question}
                key={index}
                commonQuestion={set.commonQuestion}
                answerOptions={set.answerOptions}
              />
            ))}
          </>
        );

      default:
        return (
          <>
            Undefined QuestionSet type!
          </>
        );
    }
  };

  return (
    <div className="question-set">
      <h3 className="question-set-instruction">
        Questions {set.questionInterval}
      </h3>


      <h4 className="question-set-description">
        <div dangerouslySetInnerHTML={{ __html: set.instructionLabel }} />

      </h4>

      {renderSetBody(set.type)}
    </div>
  );
}

export default QuestionSet;
